import { forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface LinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, children, href, ...props }, ref) => {
    const isInternal = href.startsWith("#") || href.startsWith("/");

    if (isInternal) {
      return (
        <a
          ref={ref}
          href={href}
          className={cn("cursor-pointer", className)}
          {...props}
        >
          {children}
        </a>
      );
    }

    return (
      <a
        ref={ref}
        href={href}
        className={cn("cursor-pointer", className)}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </a>
    );
  }
);

Link.displayName = "Link";

export { Link };
